export default __webpack_public_path__ + "static/media/LevelUp.08acd6a4.mp3";